import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden" data-testid="hero-section">
      {/* Background Image with optimized loading */}
      <motion.div
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 10, ease: 'easeOut' }}
        className="absolute inset-0"
      >
        <img
          src="/hero-mumbai.png"
          alt="Luxury Mumbai Property with Pool and Bandra-Worli Sea Link View"
          loading="eager"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary/40" />
      </motion.div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center px-6 md:px-12 lg:px-24">
        <div className="text-center max-w-5xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h1 className="font-playfair text-4xl sm:text-5xl lg:text-7xl font-bold text-primary-foreground tracking-tight leading-tight mb-6">
              <span className="block text-secondary mt-2">Venara Estate</span>
              Where Luxury Meets
              <span className="block text-secondary mt-2">Distinction</span>
            </h1>
          </motion.div>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-base md:text-lg text-primary-foreground/90 mb-12 max-w-2xl mx-auto leading-relaxed"
          >
            Curating exceptional second homes and luxury residences for discerning individuals
            across Mumbai, Alibaug, Lonavala, and Dubai.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <a
              href="#locations"
              data-testid="explore-properties-cta"
              className="group bg-secondary text-secondary-foreground hover:bg-[#C5A028] px-8 py-6 font-manrope font-bold tracking-wide uppercase text-xs transition-all duration-300 flex items-center gap-2"
            >
              Explore Properties
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform duration-300" />
            </a>
            <a
              href="/contact"
              data-testid="schedule-consultation-cta"
              className="bg-transparent border border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary px-8 py-6 font-manrope tracking-wide uppercase text-xs transition-all duration-300"
            >
              Schedule Consultation
            </a>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="w-6 h-10 border-2 border-primary-foreground/50 rounded-full flex items-start justify-center p-2"
        >
          <div className="w-1 h-2 bg-primary-foreground/50 rounded-full" />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
